import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

// Create styles similar to your HTML styles
const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: 'white',
        padding: 0,
    },
    backgroundImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '65%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundImage: `url('https://qhseelearning.sgp1.cdn.digitaloceanspaces.com/uploads/template.png')`,
    },
    content: {
        position: 'relative',
        zIndex: 1,
        padding: 15,
    },
    title: {
        textAlign: 'center',
        fontSize: 25,
        color: 'white',
        marginTop: 100,
        position: 'absolute',
        top: 50,
        left: 80,
    },
    subtitle: {
        textAlign: 'center',
        fontSize: 20,
        color: 'red',
        position: 'absolute',
        top: 70,
        left: 80,
        width:'100%',
    },
    mainContent: {
        textAlign: 'center',
        fontSize: 60,
        color: '#d5a72f',
        marginTop: 100,
    },
    courseTitle: {
        textAlign: 'center',
        fontSize: 30,
        color: 'red',
        marginTop: 70,
    },
    certificateNumber: {
        position: 'absolute',
        right: 50,
        top: 300,
        fontSize: 60,
        color: 'red',
    },
    date: {
        position: 'absolute',
        left: 70,
        bottom: 50,
        fontSize: 15,
        color: 'red',
    }
});

const ShowPdf = ({ row }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            {/* Background image */}
            <View style={styles.backgroundImage}></View>

            {/* Content */}
            <View style={styles.content}>
                <Text style={styles.title}>OF COMPLETION</Text>
                <Text style={styles.subtitle}>THIS IS TO CERTIFY THAT</Text>
                {/* <Text style={styles.mainContent}>rehan</Text>
                <Text style={styles.subtitle}>Has successfully completed the qualification for</Text>
                <Text style={styles.courseTitle}>rehan</Text>
                <Text style={styles.certificateNumber}>dddd</Text>
                <Text style={styles.date}>Dated : {new Date().toLocaleDateString('en-GB')}</Text> */}
            </View>
        </Page>
    </Document>
);

export default ShowPdf;
